import { Observable, of } from 'rxjs';
import { map, filter, take } from 'rxjs/operators';
import { SceneProvider } from './scene.provider';
import { DataAccessProvider } from './data-access.provider';

export interface SelectSurfaceResult {
    selectedHotpointId: string;
    placementOption: string;
}

export function selectSurface(
    sceneProvider: SceneProvider,
    dataAccessProvider: DataAccessProvider,
    type: 'floors' | 'walls',
): Observable<SelectSurfaceResult | null> {
    return sceneProvider.hotpointProductMap$.pipe(
        filter(Boolean),
        take(1),
        map(hotpointsMap => {
            const targetHotpoint = Object.values(hotpointsMap).find(hp => {
                const po = hp.hotpoint?.placementOption;
                if (type === 'floors') {
                    return po === 'floors';
                } else {
                    return po === 'walls' || po === 'countertops' || po === 'cabinets';
                }
            });
            if (!targetHotpoint) return null;

            const selectionMap: Record<string, boolean> = {};
            Object.keys(hotpointsMap).forEach(key => {
                selectionMap[key] = key === targetHotpoint.hotpoint.id;
            });
            sceneProvider.updateHotpointsMap(selectionMap, true);

            const filter = {
                fieldName: 'placementOptions',
                routeName: 'po',
                filterValueType: 'array' as any,
                isChildRelation: false,
                value: [targetHotpoint.hotpoint.placementOption],
            } as any;
            dataAccessProvider.patchFilters({ filters: [filter], page: 1 });

            return {
                selectedHotpointId: targetHotpoint.hotpoint.id,
                placementOption: targetHotpoint.hotpoint.placementOption,
            };
        }),
    );
}
